

























import { Prop, Component, Vue } from 'vue-property-decorator'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

@Component({ components: { } })
export default class Icon extends Vue {
  @Prop({ default: 'add' }) readonly name!: string
  @Prop({ default: false }) readonly isSvg!: boolean
  @Prop({ default: '' }) readonly path!: string
  @Prop({ default: '0 0 32 32' }) readonly viewBox!: string
  @Prop({ default: '32' }) readonly size!: string
  @Prop({ default: '' }) readonly customCss!: string
  @Prop({ default: null }) readonly tooltip!: string | boolean | object | null
}
